<template>
  <div v-if="hasInitValidState" class="container-3d">
    <v-alert
    class="save-alert"
          :value="savingDesign || completeSaveDesign"
          dense
          border="left"
          outlined
          text
          :type="savingDesign ? 'info' : 'success'"
          transition="scale-transition"
        >
          {{ !savingDesign ? $t("general.completeSaved") : $t('general.processSaving') }}
        </v-alert>
    <div
      class="d-flex h-100 justify-center align-center flex-column img-preview"
    >
    <!-- {{actualListDesign}} -->
      <v-slide-x-transition v-if="!show2dCanvas">
        <v-img
          v-show="!actualImgSelected && !show2dCanvas && !activeCanvas3d && !hasModel3D"
          :key="zona?.id + color?.code"
          :src="imgUrl"
          :lazy-src="imgUrl"
          contain
          max-height="460px"
        >
          <template #placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="primary lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-slide-x-transition>
      <canvas2d
        :id="actualZona?.id"
        :zona="actualZona"
        :img="actualImgSelected"
        :active="!hasModel3D && !!actualImgSelected"
        @save-design="saveActualDesign"
        @show-canvas="activeCanvas2d = true"
        @close-canvas="activeCanvas2d = false"
      ></canvas2d>
      <canvas3d 
        :id="actualZona?.id"
        :zona="actualZona"
        :img="actualImgSelected"
        :active="hasModel3D && activeCanvas3d"
        @save-design="saveActualDesign"
        @show-canvas="activeCanvas3d = true"
        @close-canvas="activeCanvas3d = false"
      ></canvas3d>
      <!-- <v-btn class="mt-3" @click="load3D">Active 3d</v-btn> -->
    </div>
    <v-container class="button-group" fluid>
      <v-row>
        <v-col v-if="false" class="w-100 px-0">
          <cotizador-btn disabled content-class="w-100">
            <v-icon class="mr-3">$fi-sliders</v-icon>
            {{ $t("draftliteral.draftTransforBtn") }}
          </cotizador-btn>
        </v-col>
        <v-col class="px-0">
          <cotizador-btn
            font-size="12px" 
            radio-mode 
            :disabled="!hasModel3D || !actualImgSelected || !isValidZone" class="mx-3"  
            :content-class="{ 'w-100 button-media-section': true, 'radio-active': positionMenuActive}"
            :on="{
              click: handlePositionMenu
            }"
          >
            <v-icon size="16" class="mr-3">$fi-sliders</v-icon>
            {{ $t("draftliteral.draftTransforBtn") }}
          </cotizador-btn>
        </v-col>
        <v-col v-if="!isYouReprocesos && activeBorradores" class="w-100 pa-0">
          <cotizador-btn disabled content-class="w-100">
            <v-icon size="16" class="mr-3">$fi-upload</v-icon>
            {{ $t("draftliteral.draftSavedDesignsBtn") }}
          </cotizador-btn>
        </v-col>
        <v-col class="w-100 px-0">
          <cotizador-btn
            font-size="12px"
            :disabled="!isValidZone || actualImgSelected?.textDesign"
            :on="{
              click: () => {
                showDialogUpdateFile = true;
              }
            }" class="ml-3" content-class="w-100 button-media-section">
             <v-icon size="16" class="mr-3">$fi-upload</v-icon>
            {{
              !activeCanvas2d
                ? $t("draftliteral.loadDraftAlternative")
                : $t("presupuesto.editCanvasTitle")
            }}
          </cotizador-btn>
           <update-file-dialog
            :dialog.sync="showDialogUpdateFile"
            :zona="zona"
            without-activator
            :disabled="(hasModel3D && !activeCanvas3d) || !isValidZone"
            :is-active3-d="hasModel3D && activeCanvas3d"
            @update-image="storeActualImg"
          />
        </v-col>
        <v-col v-if="hasModel3D && activeCanvas3d" class="w-100 px-0">
          <cotizador-btn
            font-size="12px"
            :disabled="!isValidZone || !!actualImgSelected?.base64"
            :on="{
              click: () => {
                showDialogAddText = true;
              }
            }" class="ml-3" content-class="w-100 button-media-section">
             <v-icon size="16" class="mr-3">$fi-type</v-icon>
            Añadir texto al modelo
          </cotizador-btn>
          <update-text-dialog
            :dialog.sync="showDialogAddText"
            :zona="zona"
            without-activator
            :disabled="(hasModel3D && !activeCanvas3d) || !isValidZone"
            :is-active3-d="hasModel3D && activeCanvas3d"
            @update-image="storeActualImg"
          />
        </v-col>
      </v-row>
      <v-slide-y-transition>
        <v-row >
          <v-col class="w-100 pa-0">
            <v-container>
              <v-slide-y-transition>
                <position-banner
                  v-if="positionMenuActive && actualImgSelected"
                  :img="actualImgSelected"
                  :zona="zona"
                />
              </v-slide-y-transition>
            </v-container>
          </v-col>
        </v-row>
      </v-slide-y-transition>
    </v-container>

  </div>
</template>

<script>
import { noImgUrl, checkImageValid } from "@/utils/imageUtils";
import { setBackgroundToSvg } from "@/utils/fabricUtils";
import canvas2d from "@/components/cotizadorClientes/canvas2d.vue";
import canvas3d from "@/components/cotizadorClientes/canvas3d.vue";
import updateFileDialog from "@/components/modales/updateFileDialog.vue";
import updateTextDialog from "@/components/modales/updateTextDialog.vue";
import positionBanner from "@/components/cotizadorClientes/positionBanner.vue";

import CotizadorBtn from "@/components/basic/CotizadorBtn.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    CotizadorBtn,
    canvas2d,
    updateFileDialog,
    canvas3d,
    positionBanner,
    updateTextDialog
  },
  props: {
    color: {
      type: Object,
      validator: function (value) {
        return value?.code;
      },
      default: null
      // required: true
    },
    zona: {
      type: Object,
      validator: function (value) {
        return value?.Posicion && value?.Zona;
      },
      default: () => {
        return {
          id: -1,
          Posicion: "",
          Zona: "",
          PreviewRule: ""
        };
      }
      // required: true
    },
    active: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // Genérico para ambos tipos de canvas
      actualImgSelected: null, // Imagen seleccionada
      showDialogUpdateFile: false, // Dialogo para mostrar el modal para subir una imagen
      showDialogAddText: false, // Dialogo para mostrar el modal para añdir un texto al modelo

      // Variable usables para el canvas 2d
      activeCanvas2d: false, // Booleano para mostrar el canvas 2d

      // Variables usables para el canvas 3d
      activeCanvas3d: false, // Booleano para mostrar el canvas 3d

      // Dos booleanos extras para mostrar el mensaje de guardado
      savingDesign: false, // Indica que hemos empezado a guardar el diseño
      completeSaveDesign: false, // Indica que acabamos de completar de guardar el diseño

      positionMenuActive: false, // Indica si el menú de posiciones está activo
    };
  },
  computed: {
    ...mapGetters("modelo", [
      "modelPrice",
      "newComputedImgUrl",
      "hasModel3D",
      "modelCode",
      "modelSlug"
    ]),
    ...mapGetters("config", ["isYouReprocesos", "colorSelected", "activeBorradores"]),
    ...mapGetters("design", ["actualListDesign", "filteredListDesignInCart",
      "loadingDesign", 'activeZoneMaxSize']),
    imgUrl() {
      return this.newComputedImgUrl(this.actualZona, this.color?.code) ?? noImgUrl;
    },
    imgCustom: function () {
      let design = this.actualListDesign.find(
        d => d.id == this.actualZona.id && d.posicion == this.actualZona.Posicion
      );
      if (design && design.svg) return design.svg;
      return null;
    },
    // Diseño para la zona actual
    actualDesign() {
      if(!this.actualListDesign?.length) {
        return null;
      }

      let design = this.searchFromDesignList();

      return design;
    },
    show2dCanvas() {
      return this.activeCanvas2d && this.actualDesign?.mode == "2d";
    },
    // Creamos un fallback de zona para poder generarlo sin seleccionar nada
    actualZona() {
      return this.zona ?? {
          id: -1,
          Posicion: "",
          Zona: "",
          PreviewRule: ""
        };
    },
    // Comprueba si estamos listos para mostrar el menu
    hasInitValidState() {

      return this.modelCode && this.color && (
        this.hasModel3D 
        || (!this.hasModel3D && this.actualZona?.id >=0)
      )
    },
    isValidZone() {
      return this.actualZona?.id >= 0 && this.actualZona?.Posicion && this.actualZona?.Zona;
    }
   },
  watch: {
    zona(newVal, oldVal) {
      if (newVal != oldVal) {
        this.positionMenuActive = false;
      }
    },
    loadingDesign(newVal, oldVal) {
      if (newVal == oldVal && newVal == this.savingDesign) {
        return;
      }

      if (newVal != this.savingDesign) {
         this.savingDesign = newVal;
        if (!newVal && oldVal) {
          this.completeSaveDesign = true;

            setTimeout(async () => {
              // Hacemos el emit para que se guarde el diséño
              this.completeSaveDesign = false
            }, 2500);
        }
      }
    },

    modelCode(newVal, oldVal) {
      if (newVal != oldVal) {
        this.actualImgSelected = null; // Reseteamos la imagen seleccionada al cambiar el modelo
        this.showDialogUpdateFile = false; // Reseteamos el dialogo de actualización de archivo
        this.activeCanvas2d = false; // Reseteamos el canvas 2d
        this.activeCanvas3d = false; // Reseteamos el canvas 3d
        this.positionMenuActive = false; // Reseteamos el menú de posiciones
        this.savingDesign = false; // Reseteamos el estado de guardado
        this.completeSaveDesign = false; // Reseteamos el estado de guardado completo
      }
    },

    filteredListDesignInCart: {
      handler(newVal, oldVal) {
        if (newVal?.length < oldVal?.length) {
          // Se ha borrado un diseño, debemos comprobar si es nuestra imagen

          const isDesignOnList = newVal.find(design => design.id == (this.zona?.id ?? -1) && design.posicion == this.zona.Posicion)

          if (!isDesignOnList) {
            this.storeActualImg(null);
          }
        }

      },
      deep: true
    }
  },
  methods: {
    ...mapActions("design", ["saveZoneCustomDesign"]),
    storeActualImg(img) {
      this.actualImgSelected = img;
    },
    /**
     * Guarda el diseño actual
     * @param {Object} zoneToSave Parámetro opcional. Si se proporciona, se guardará para la zona indicada
     *
     * El tema del parámetro opcional, es porque al ser llamado desde el watcher de zona, se guarda con el id de destino, no el real
     */
    saveActualDesign({ zoneToSave, canvas2dInfo }) {

      if (!this.actualImgSelected) {
        throw new Error(
          "No se ha seleccionado ninguna imagen para poder guardar el diseño"
        );
      }

      if (
        !this.actualImgSelected ||
        (this.actualImgSelected.id == 0 &&
          !this.actualImgSelected.observaciones)
      ) {
        console.warn(
          "No se ha seleccionado ninguna imagen para guardar, ni ninguna observación",
          this.actualImgSelected
        );
        return;
      }

      let informationActualZone = {
        id: zoneToSave?.id ?? this.actualZona.Id,
        tecnica: this.tecnica,
        zona: zoneToSave?.Zona ?? this.actualZona.Zona,
        posicion: zoneToSave?.Posicion ?? this.actualZona.Posicion,
        design:
          this.actualImgSelected.id > 0 ? this.actualImgSelected.base64 : null,
        originalFile: this.actualImgSelected.originalFile,
        observaciones: this.actualImgSelected.observaciones,
        idImg: this.actualImgSelected.id,
        textDesign: this.actualImgSelected.textDesign,
        fontDesign: this.actualImgSelected.fontSelected,
        colorPicker: this.actualImgSelected.colorPicker,
        previewRule: zoneToSave?.PreviewRule ?? this.actualZona.PreviewRule,
        numColor: this.actualImgSelected.numColor,
        visualColors: this.actualImgSelected.visualColors ?? []
      };

      if (this.activeCanvas2d) {
        informationActualZone.mode = "2d";


        if (canvas2dInfo) {
          informationActualZone.svg = canvas2dInfo?.svg;
          informationActualZone.canvasJson = canvas2dInfo?.canvasJson;
          informationActualZone.baseBackgroundImg =
            informationActualZone.canvasJson.backgroundImage.src;

          let imageWithoutFondo = this.newComputedImgUrl(
            zoneToSave ?? this.actualZona,
            this.colorSelected,
            true
          );

          if (
            checkImageValid(imageWithoutFondo) &&
            imageWithoutFondo != informationActualZone.baseBackgroundImg
          ) {

            informationActualZone.svg =
              setBackgroundToSvg(
                informationActualZone.svg,
                imageWithoutFondo
              ) ?? informationActualZone.svg;

          }
        }

      }

      if(this.activeCanvas3d) {
        informationActualZone.mode = "3d";
      }

      this.saveZoneCustomDesign(informationActualZone);
    },
    searchFromDesignListWithImage() {
      return this.searchFromDesignList({ withImage: true });
    },
    searchFromDesignList({ withImage = false } = {}) {
      // Buscamos si alguno de los diseños coincide en Id
      let design = this.actualListDesign.find(
        x =>
          x.id == this.actualZona.id &&
          this.actualZona.Posicion == x.posicion &&
          x.mode == "2d" &&
          (!withImage || this.actualImgSelected?.id == x.idImg)
      );

      return design;
    },
    handlePositionMenu() {
      this.positionMenuActive = !this.positionMenuActive;
    }
  }
};
</script>

<style lang="scss">
.container-3d {
  max-width: 100%;
  width: 100%;
  height: calc(100vh - 257px);
  max-height: 825px;

  position: sticky;
  top: 0;
  margin-top: 25px;

  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;

  .button-media-section {
    font-size: 8px;
  }

  .save-alert {
    position: absolute;
    top: 15px;
    padding: 10px 25px;
  }

  .img-preview {
    .custom-svg {
      max-width: 460px;
    }
  }

  .button-group {
    // min-height: 96px;
    // padding-bottom: 0px;
    padding-top: 50px;
    .v-btn {
      border-radius: 0px !important;
    }
  }
}
</style>
